module.exports = __webpack_public_path__ + "img/tree.356d7bcf.png";